import { initGlobalState } from 'qiankun';
var initState = {};
var actions = initGlobalState(initState);
export default actions;